import { AppstoreOutlined, BarcodeOutlined, DatabaseOutlined } from '@ant-design/icons';
import { Col, Form, type FormInstance, Row, Tabs } from 'antd';
import type { FormProdutoValues } from '@/features/produto/types/FormProdutoValues';
import type { OrdenarLotes } from '@/features/produto/types/OrdenarLotes';
import { Container } from '@/components/Container';
import { InputNumber } from '@/components/input/InputNumber';
import { CustomSwitch } from '@/components/revisar/CustomSwitch';
import { ProdutoTabEstoqueLocal } from './local/ProdutoTabEstoqueLocal';
import { ProdutoTabEstoqueLote } from './lote/ProdutoTabEstoqueLote';
import { ProdutoTabEstoquePacote } from './pacote/ProdutoTabEstoquePacote';

export function ProdutoTabEstoque({
    form,
    ordenarLotes,
    setFormDirty,
}: {
    form: FormInstance<FormProdutoValues>;
    ordenarLotes: OrdenarLotes;
    setFormDirty: (dirty: boolean) => void;
}) {
    const pro_controlar_estoque = Form.useWatch('pro_controlar_estoque', form);
    const controlaEstoque = pro_controlar_estoque === 1;

    return (
        <>
            <Container>
                <Row gutter={8}>
                    <Col md={8} sm={12} xs={12}>
                        <Form.Item
                            className='mb-3'
                            label='Controlar Estoque'
                            name='pro_controlar_estoque'
                        >
                            <CustomSwitch checked='Sim' unchecked='Não' />
                        </Form.Item>
                    </Col>

                    <Col md={8} sm={12} xs={12}>
                        <Form.Item
                            className='mb-3'
                            label='Permitir Venda Fracionada'
                            name='pro_permite_venda_fracionada'
                        >
                            <CustomSwitch checked='Sim' unchecked='Não' />
                        </Form.Item>
                    </Col>

                    <Col md={8} sm={12} xs={12}>
                        <Form.Item
                            className='mb-3'
                            hidden={!controlaEstoque}
                            label='Permitir Estoque Negativo'
                            name='pro_permite_estoque_negativo'
                        >
                            <CustomSwitch checked='Sim' unchecked='Não' />
                        </Form.Item>
                    </Col>

                    <Col md={8} sm={12} xs={12}>
                        <Form.Item
                            className='mb-3'
                            hidden={!controlaEstoque}
                            label='Estoque Mínimo'
                            name='pro_estoque_minimo'
                        >
                            <InputNumber decimalScale={4} />
                        </Form.Item>
                    </Col>

                    <Col md={8} sm={12} xs={12}>
                        <Form.Item
                            className='mb-3'
                            hidden={!controlaEstoque}
                            label='Quantidade Fração'
                            name='pro_quantidade_fracao'
                            tooltip='Exemplo: Produto comprado em Caixa com 12 unidades e vendido em unidade. Fração = 12'
                        >
                            <InputNumber decimalScale={4} />
                        </Form.Item>
                    </Col>
                </Row>
            </Container>

            <Tabs
                items={[
                    {
                        children: (
                            <ProdutoTabEstoqueLocal form={form} setFormDirty={setFormDirty} />
                        ),
                        icon: <DatabaseOutlined />,
                        key: 'local',
                        label: 'Locais de estoque',
                    },
                    {
                        children: (
                            <ProdutoTabEstoqueLote
                                form={form}
                                ordenarLotes={ordenarLotes}
                                setFormDirty={setFormDirty}
                            />
                        ),
                        icon: <AppstoreOutlined />,
                        key: 'lote',
                        label: 'Lotes',
                    },
                    {
                        children: (
                            <ProdutoTabEstoquePacote form={form} setFormDirty={setFormDirty} />
                        ),
                        icon: <BarcodeOutlined />,
                        key: 'pacote',
                        label: 'Código de barras e pacotes',
                    },
                ]}
            />
        </>
    );
}
